<template>
  <div class="staging-wrap">
    <div class="description">
      WELCOME!&nbsp;欢迎来到到家科技ERP
    </div>
    <div class="app-list">

      <div class="app-item" @click="navTo('https://yc.crm.gdzawy.com:9000/')">
        <el-image src="/static/staging/yongcheng.png?v=20250417" style="background-color: #fff;" />
      </div>

      <div class="app-item" @click="navTo('https://crm.szjwwy.net/')">
        <el-image src="/static/staging/jianwu.png?v=20240403" />
      </div>

      <div class="app-item" @click="navTo('https://hr.crm.gdzawy.com:9000/')">
        <el-image src="/static/staging/huarui.png?v=20240403" />
      </div>
      <div class="app-item" @click="navTo('https://zb.crm.gdzawy.com/')">
        <el-image src="/static/staging/zhongbao.jpg?v=20251201" />
      </div>

      <div class="app-item" @click="navTo('http://ningbozhongpai.ppinsoft.cn:21573/webapp')">
        <el-image src="/static/staging/zonpi.png?v=20241125" />
      </div>
      <div class="app-item" @click="navTo('https://city.51homemoney.com:9000/smart-city-screen/#/')">
        <el-image src="/static/staging/zhihuihuanwei.jpg?v=20250121" />
      </div>

    </div>

    <div class="app-list" style="margin-top: 5px">
      <div class="app-item" @click="navTo('https://atcservice.51homemoney.com/base/#/login')">
        <el-image src="/static/staging/aopark.png?v=20251107" />
      </div>
      <div class="app-item" @click="navTo('http://admin.ts.yobohome.cn/login')">
        <el-image src="/static/staging/yobo.png?v=20240313" />
      </div>
      <div class="app-item" @click="navTo(ekpt.url_path)">
        <el-image src="/static/staging/cdj.png?v=20240313" />
      </div>

      <div class="app-item" @click="navTo('https://devshare.gdzawy.com:8091/')">
        <el-image src="/static/staging/finance-share.png?v=20260429" style="background-color: #fff" />
      </div>
<!--      <div class="app-item" @click="navTo('https://oa.gdzawy.com:8888/mainui/mainuiv9.html')">-->
<!--        <el-image src="/static/staging/new_windows.png?v=20240313" />-->
<!--      </div>-->
      <div class="app-item" @click="navTo('wework://')">
        <el-image src="/static/staging/we_work.png?v=20240313" />
      </div>

      <div class="app-item" @click="navTo('wemeet://')">
        <el-image src="/static/staging/we_meet.png?v=20240313" />
      </div>
      <!--      <div class="app-item" @click="navTo('https://tf.jdy.com/sec/ierp/login.html')">-->
      <!--        <el-image src="/static/staging/kingdee.png?v=20240313" />-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import Http from "./common/Http";
export default {
  name: "Staging",
  data() {
    return{
      ekpt : ''
    }
  },
  mounted() {
    this.getEkpt()
  },
  methods:{
    navTo(item){
      window.open(item)
    },
    getEkpt() {
      Http.get(Http.getPreBaseURL() + "/oa/Staging/getEkpt", {}, res => {
        if (res.code === 0) {
          this.ekpt = res.data;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}

.staging-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: url('/static/staging/bg.png');

  .description {
    text-align: center;
    font-size: 2vw;
    line-height: 40px;
    color: #cecdd8;
    letter-spacing: 1px;
    padding: 0 10px;
    margin-top: -7vw;
    margin-bottom: 4.5vw;
  }

  .app-list {
    padding: 0 30px;
    display: flex;
    max-width: 1600px;

    .app-item {
      cursor: pointer;
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Staging.vue